import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ForWho } from './components/ForWho';
import { Problem } from './components/Problem';
import { Planillas } from './components/Planillas';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { EliteProValue } from './components/EliteProValue';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    let active = true;
    import('react-facebook-pixel').then(module => module.default).then(ReactPixel => {
      if (!active) return;
      ReactPixel.init(META_PIXEL_ID);
      ReactPixel.pageView();
    });
    return () => {
      active = false;
    };
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ForWho data-id="element-4" />
      <Problem data-id="element-5" />
      <Planillas data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <Pricing data-id="element-9" />
      <EliteProValue data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}